<template>
	<div class="table-view-results-tab display-flex flex-column height-100">
		<div class="flex-space-between--center" v-if="!isObjectOutput">
			<div class="search-field"><AppSearch :searchString.sync="searchString" /></div>
		</div>
		<div class="test-results-tab display-flex flex-column height-100">
			<div v-if="isTextOutput">
				<div class="row-result" v-for="(row, index) in filteredTextOutput" :key="index">
					{{ row }}
				</div>
			</div>
			<TableView
				class="flex-1"
				v-else-if="tableOutput && !isEmptyTableResults"
				:headers="columnDefs"
				:rows="filteredTableOutput"
				:gridOptions="{ suppressFieldDotNotation: true }"
			/>
			<div v-else-if="tableOutput && isEmptyTableResults" class="flex-centerize height-100">
				<div class="empty-message">Resulted in an Empty Table</div>
			</div>
			<div v-else class="flex-centerize height-100">
				<div class="empty-message">Press "Test And Continue" in order to see the results here</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import TableActionEditorService from '../../BlockEditor/TableActionEditor/table-action-edtior-service';
import TableView from '@/components/common/TableView/TableView';
import { editNode } from '@/store/modules/selectedNode/getters';
import { getNode } from '@/store/modules/nodes/getters';
import { TEST_RESULT_STATUSES } from '@/utils/workflow-node.const';
import { flattenPreserveArrays } from '@/utils/helpers';

export default {
	name: 'TestResultsTab',
	components: {
		TableView,
	},
	props: {},
	computed: {
		...mapGetters([getNode.fullPath, editNode.fullPath]),
		selectedNode() {
			return this[getNode.fullPath](this[editNode.fullPath].id);
		},
		isTestedError() {
			return this.selectedNode && this.selectedNode.test_result_status === TEST_RESULT_STATUSES.ERROR;
		},
		testResults() {
			return !this.isTestedError ? this.selectedNode.test_result : null;
		},
		tableOutput() {
			return flattenPreserveArrays(this.testResults?.results || (this.isObjectOutput ? [this.objectOutput] : []));
		},
		columnDefs() {
			if (!this.tableOutput) {
				return [];
			}
			return TableActionEditorService.columnDefsFromPreviousSteps(this.tableOutput);
		},
		isEmptyTableResults() {
			return this.tableOutput && this.tableOutput.length === 0;
		},
		hasOneResult() {
			return this.testResults && !this.testResults.results && this.testResults.result;
		},
		isTextOutput() {
			return this.hasOneResult && isString(this.testResults.result);
		},
		isObjectOutput() {
			return this.hasOneResult && isObject(this.testResults.result);
		},
		objectOutput() {
			return this.testResults?.result || {};
		},
		textOutputAsList() {
			return this.testResults?.result?.split(',') || [];
		},
		filteredTextOutput() {
			return this.filteredResults(this.textOutputAsList);
		},
		filteredTableOutput() {
			return this.filteredResults(this.tableOutput);
		},
	},
	methods: {
		filteredResults(list) {
			const strToSearch = this.searchString.toLowerCase();
			if (strToSearch) {
				return list.filter((row) => {
					if (isString(row)) {
						return row.toLowerCase().includes(strToSearch);
					}

					const rowIncludessearchString = (result, columnVal) => result || columnVal.toString().toLowerCase().includes(strToSearch);
					return Object.values(row).reduce(rowIncludessearchString, false);
				});
			}
			return list;
		},
	},
	data: () => ({ searchString: '' }),
};
</script>

<style scoped lang="scss">
.test-results-tab {
	.row-result {
		text-align: left;
	}

	.empty-message {
		max-width: 300px;
		font-size: 20px;
		color: var(--secondary-font-color);
	}
}
</style>
